import { useTranslation } from "react-i18next";
import { clapperPhoto, studioStats } from "@/mocks/home";

export default function About() {
  const { t } = useTranslation();

  const points = [
    t("about.pointOne"),
    t("about.pointTwo"),
    t("about.pointThree"),
  ];

  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-primary-400"></span>
              <span className="font-label text-sm uppercase tracking-[0.3em] text-primary-600">
                {t("about.kicker")}
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
              {t("about.title")}
            </h2>
            <p className="mt-6 text-base leading-relaxed text-foreground-600">
              {t("about.body")}
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              {t("about.body2")}
            </p>

            <ul className="mt-8 space-y-3">
              {points.map((point) => (
                <li key={point} className="flex items-center gap-3">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-secondary-100 text-secondary-700">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  <span className="text-sm md:text-base text-foreground-800">{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src={clapperPhoto}
                alt="A film clapperboard and notes resting on a rock at a shoot location"
                title="barewitness films on location"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 -left-4 md:left-6 bg-accent-500 text-background-50 rounded-md px-5 py-4">
              <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-100">
                On Location
              </p>
              <p className="font-heading text-lg font-semibold">Day 1 · 7:11 AM</p>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-2 lg:grid-cols-4 border-t border-background-200">
          {studioStats.map((stat, index) => (
            <div
              key={stat.id}
              className={`py-7 md:py-9 px-2 md:px-4 ${
                index !== 0 ? "border-l border-background-200" : ""
              } ${index === 2 ? "border-t lg:border-t-0 border-background-200" : ""}`}
            >
              <p className="font-heading text-4xl md:text-5xl font-bold text-primary-600">
                {stat.value}
              </p>
              <p className="mt-2 font-label text-xs md:text-sm uppercase tracking-[0.16em] text-foreground-500">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}